import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";

import pages from "../../../constants/pages";
import { PageHeader, Paper, TextField } from "../../../components";
import { colors } from "../../css components/Style";

export default function FormOne({ formikProps }) {
  const navigate = useNavigate();
  const { role } = useSelector((state) => state.memberDetails);

  return (
    <Grid container spacing={4}>
      <Grid size={12}>
        <PageHeader
          pageName={"Profile Information"}
          pageHeader="View and manage personal information"
        />
      </Grid>

      <Grid size={12}>
        <Paper>
          <Grid size={4}>
            <TextField
              name="displayName"
              placeholder="Display Name"
              label="Display Name"
              disabled
              formikProps={formikProps}
            />
          </Grid>
          <Grid size={4}>
            <TextField
              disabled
              name="givenName"
              placeholder="Given Name"
              label="Given Name"
              formikProps={formikProps}
            />
          </Grid>
          <Grid size={4}>
            <TextField
              disabled
              name="familyName"
              placeholder="Family Name"
              label="Family Name"
              formikProps={formikProps}
            />
          </Grid>
          <Grid size={4}>
            <TextField
              disabled
              name="email"
              placeholder="Email"
              label="Email"
              formikProps={formikProps}
            />
          </Grid>
          <Grid size={4}>
            <TextField
              placeholder="Role"
              label="Role"
              disabled
              name="role"
              formikProps={formikProps}
            />
          </Grid>

          {role === "AGENCY" && (
            <Grid size={12}>
              <Typography
                color={colors.publicisBlue}
                variant="caption1"
                style={{ cursor: "pointer" }}
                onClick={() => navigate(pages.changePassword.route)}
              >
                Change Password
              </Typography>
            </Grid>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
}
